import { useState } from 'react';
import styled from 'styled-components';
import logo from '../images/logo-drops-black.png';
import { ReactComponent as MenuIcon } from '../images/menu.svg';
import { ReactComponent as CloseIcon } from '../images/close.svg';
import { ReactComponent as FacebookIcon } from '../images/facebook-icon.svg';
import { ReactComponent as EmailIcon } from '../images/email-icon.svg';

const LogoLink = styled.a`
  display: inline-flex;

  img {
    margin: 12px 4px;
    width: 180px;
    @media (max-width: 1000px) {
      width: 137px;
    }

    @media (max-width: 400px) {
      width: 114px;
    }
  }
`;
const NavLink = styled.a`
  text-decoration: none;
  color: var(--black);
  display: inline-flex;
  margin: 0 4px;
  padding: 12px 16px;

  &:hover {
    border-radius: 24px;
    background: var(--black);
    color: white;
  }
`;

const NavButton = styled(NavLink)`
  padding: 0;
  margin: 0 8px;
  svg {
    height: 24px;
    width: 24px;
    padding: 10px;
    border: 2px solid var(--black);
    border-radius: 24px;
  }
`;

const NavButtons = styled.div``;

const DesktopNav = styled.nav`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 56px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileNav = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 801px) {
    display: none;
  }
`;

const MobileNavHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 6px 12px;
`;

const DesktopNavMenu = styled.div`
  display: flex;
  align-items: center;
`;

const MobileNavMenu = styled.div`
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--light-beige);
  height: 0;
  overflow: hidden;
  transition: height 0.3s ease;
  &.open {
    height: 240px;
  }
  ${NavLink} {
    margin: 0;
  }
  ${NavButton} {
    margin: 10px 6px;
  }
`;
const IconButton = styled.button`
  width: 24px;
  height: 24px;
  background: none;
  padding: 0;
  border: none;

  svg {
    width: 24px;
    height: 24px;
  }
`;

const links = [
  <NavLink href="/activities">Inicjatywy</NavLink>,
  <NavLink href="/faq">FAQ</NavLink>,
  <NavLink href="/privacy-policy">Polityka prywatności</NavLink>,
  <NavButtons>
    <NavButton
      href="https://www.facebook.com/DuszpasterstwoRodzinDROPS"
      target="_blank"
    >
      <FacebookIcon />
    </NavButton>
    <NavButton href="mailto:drops.sluzew@dominikanie.pl">
      <EmailIcon />
    </NavButton>
  </NavButtons>,
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const logoLink = (
    <LogoLink href="/">
      <img src={logo} alt="logo" />
    </LogoLink>
  );

  return (
    <header>
      <DesktopNav>
        {logoLink}
        <DesktopNavMenu>{links}</DesktopNavMenu>
      </DesktopNav>

      <MobileNav>
        <MobileNavHeader>
          {logoLink}
          <IconButton
            onClick={() => setMenuOpen(!menuOpen)}
            className={menuOpen ? 'open' : 'closed'}
          >
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </MobileNavHeader>
        <MobileNavMenu
          className={menuOpen ? 'open' : 'closed'}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {links}
        </MobileNavMenu>
      </MobileNav>
    </header>
  );
}
